import appSettings from 'apps/services/config';


const envType = 'DEV';
const url=appSettings.enquiry_url;

export const connection = {
    'DEPLOY_URL': url,
    
}

export default connection;